
























































































import Vue from 'vue';
import Component from 'vue-class-component';
import {  Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import DxToolbar from 'devextreme-vue/toolbar';
import { DxCheckBox } from 'devextreme-vue';
import _ from "lodash";
import { DataGrid } from '@questelservices/common-vue';
import { DxHtmlEditor } from 'devextreme-vue/html-editor';
import {
  DxDataGrid,
  DxColumn
} from 'devextreme-vue/data-grid';
import { Popup } from '@questelservices/common-vue';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { FeeSheetRowDto, FeeSheetRowTypeEnum } from '@/models/Fees/FeeSheetRowDto';


@Component({
  components: {
    Popup,
    DxDataGrid,
    DxHtmlEditor,
    DxColumn,
    DxToolbarItem,
    DxCheckBox
  }
})
export default class ParentFeeSheetRowDetails extends Vue {
    @Prop({default : {
        Description: "",
        PhaseOrInfractionName: "",
        Signed: false,
        CapDisplay: "",
        FeeSheetRowType: FeeSheetRowTypeEnum.Phase
    }})
    parentFeeSheetRow!: any

    get parentFeeSheetRowValue() {
        if(this.parentFeeSheetRow) {
            this.isForPhase = this.parentFeeSheetRow.FeeSheetRowType == FeeSheetRowTypeEnum.Phase ? true : false;
            return [this.parentFeeSheetRow];
        }
        else{
            return [];
        }
    }

    @Prop({ default: false })
    showDialog!: boolean;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value:boolean) {
        this.hidingModal();
    }

    private hidingModal(): void {
        this.$emit("hiding");
    }
    isForPhase: boolean = true;

    onPopupShown(e:any) {

    }
    onPopupHidden(e:any) {

    }

    setAttr(name: string, value: any) : any {
        return Object.keys(this.$attrs).indexOf(name) > -1 ? this.$attrs[name] : value;
    }
    onCancel(e: any) {
        this.showingDialog = false;
    }
    displayCaption() {
        if(this.isForPhase) {
            return "Phase Name";
        }
        else{
            return "Infraction Name";
        }
    }
}

